export default "__VITE_ASSET__PBSFRUjW__"